import { render, staticRenderFns } from "./otp-input.vue?vue&type=template&id=5fa35f11&scoped=true"
import script from "./otp-input.vue?vue&type=script&lang=ts"
export * from "./otp-input.vue?vue&type=script&lang=ts"
import style0 from "./otp-input.vue?vue&type=style&index=0&id=5fa35f11&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa35f11",
  null
  
)

export default component.exports